<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 日本入荷詳細画面（大連工場） -->
      <div :style="{ height: basicHeight + 'px' }">
        <!-- 日本入荷基本情報 -->

        <t-form label-position="right" label-width="100px">
          <t-collapse v-model="activeNames" @change="handleCollapseChange">
            <t-collapse-item title="日本入荷基本情報" name="receDLBasic">
              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 運送No. -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.TRANSPORT_NO')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="jpReceEditForm.jrbTransOrderNo"
                      class="commonDialog"
                      maxLength="20"
                      :disabled="editDisableFlg"
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <!-- 出発日 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.DEPARTURE_DATE')"
                    class="marginBottom"
                  >
                    <t-date-picker
                      v-model="jpReceEditForm.jrbDepartureDateOnly"
                      class="dialogDate"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :disabled="editDisableFlg"
                    >
                    </t-date-picker>
                  </t-form-item>
                </t-col>

                <!-- 入荷日 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.RECEIVE_DATE')"
                    class="marginBottom"
                  >
                    <t-date-picker
                      v-model="jpReceEditForm.jrbReceDateOnly"
                      class="dialogDate"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :clearable="false"
                    >
                    </t-date-picker>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colCom">
                  <!-- 担当者 -->
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.CONNECTER_NAME')"
                    class="marginBottom"
                  >
                    <t-select
                      v-model="jpReceEditForm.jrbUserCode"
                      placeholder=""
                      class="commonDialog"
                    >
                      <t-option
                        v-for="item in connecterList"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>
              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 状態 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.STATUS')"
                    class="marginBottom"
                  >
                    <t-select
                      v-model="jpReceEditForm.jrbReceStatus"
                      placeholder=""
                      class="commonDialog"
                    >
                      <t-option
                        v-for="item in jrbReceStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <!-- 支払状態 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.PAY_STATUS')"
                    class="marginBottom"
                    v-show="!localIsAdd"
                  >
                    <t-select
                      v-model="jpReceEditForm.jrbPayStatus"
                      placeholder=""
                      class="commonDialog"
                      :disabled="editDisableFlg"
                    >
                      <t-option
                        v-for="item in PayStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colCom * 2"> </t-col>
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>

              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 備考 -->
                <t-col :span="colArr.colCom * 4">
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.REMARKS')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="jpReceEditForm.jrbRemarks"
                      type="textarea"
                      maxlength="500"
                      class="commonDialog dialog_bikou"
                      placeholder="備考"
                      show-word-limit
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>
            </t-collapse-item>
          </t-collapse>

          <t-row>
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
              class="col_common_left"
            >
              <!-- 運送台帳選択 -->
              <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
              <!-- <t-button
                round
                type="primary"
                class="button_long_search"
                ref="jpReceDLSelectBtn"
                @click="jpReceDLSelectDialog"
                :disabled="transSelectFlg"
              >
                <i class="el-icon-s-order"></i>
                {{ $t("resource.JP_RECEIVE.TRANSPORT_LIST_SELECT") }}
              </t-button> -->

              <t-button
                round
                type="primary"
                class="button_long_search"
                ref="jpReceDLSelectBtn"
                @click="jpReceDLSelectDialog"
                :disabled="!localIsAdd"
              >
                <i class="el-icon-s-order"></i>
                {{ $t("resource.JP_RECEIVE.TRANSPORT_LIST_SELECT") }}
              </t-button>
            </t-col>

            <!-- UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓ -->
            <!-- 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する -->
            <!-- <t-col :span="16">&nbsp;</t-col> -->

            <t-col :span="5">&nbsp;</t-col>
            <t-col :span="5" class="col_common_left">
              <t-input
                ref="searchInput"
                v-model="searchWord"
                placeholder="キーワードを入力して検索する"
                @blur="handleSearchChange"
                maxLength="50"
                @clear="handleClear"
                @keyup.native.enter="handleSearchChange"
                class="input_icon_close"
                style="margin-top: 10px"
                clearable
              >
                <t-button
                  slot="append"
                  icon="el-icon-search"
                  class="button-default custom-button"
                  @click="handleSearchChange"
                ></t-button>
              </t-input>
            </t-col>
            <t-col :span="6">&nbsp;</t-col>
            <!-- UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑ -->

            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
              class="right"
            >
              <!-- 入荷チェックリスト出力 -->
              <!-- <t-button
                round
                type="primary"
                class="button_long_search"
                @click="OutPutClick"
                :disabled="outPutClickFlg"
              >
                <i class="el-icon-download"></i>
                {{ $t("resource.JP_RECEIVE.RECE_CHECK_OUTPUT") }}
              </t-button> -->
            </t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col :span="24">
            <!-- テーブル -->
            <div>
              <!-- UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓ -->
              <!-- 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する -->
              <!-- <t-table
                ref="jrbReceInfoTable"
                :data="jrbReceInfoTable"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :cell-class-name="tableCellClassName"
                :row-class-name="rowClassName"
                :height="detailHeight"
                border
                fit
              > -->
              <t-table
                ref="jrbReceInfoTable"
                :data="filteredDetailTable"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :cell-class-name="tableCellClassName"
                :row-class-name="rowClassName"
                :height="detailHeight"
                border
                fit
              >
                <!-- UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑ -->

                <!-- テーブルの列 -->
                <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_画面と文字サイズの調整 -->
                <!--  <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                > -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="`${column.class} input_font_small`"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                  <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                  <template slot-scope="scope">
                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
                    <!-- <t-input-number
                      v-if="editCellData(scope.row, column)"
                      class="cell_input_number"
                      :controls="false"
                      :precision="0"
                      :min="0"
                      :max="999999"
                      width="100%"
                      v-model="scope.row[column.prop]"
                      @change="changeCellData(scope.row, column.prop)"
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                    />

                    <t-input
                      v-else-if="
                        column.prop === 'jrdRemarks' &&
                        scope.row.jrdUpdFlg !== '1'
                      "
                      maxLength="200"
                      v-model="scope.row[column.prop]"
                      :disabled="scope.row.jrdUpdFlg === '1'"
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                    /> -->

                    <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                    <!-- 課題_画面と文字サイズの調整 -->
                    <!-- <t-input-number
                      v-if="editCellData(scope.row, column)"
                      class="cell_input_number"
                      :controls="false"
                      :precision="0"
                      :min="0"
                      :max="99999"
                      width="100%"
                      v-model="scope.row[column.prop]"
                      @blur="changeCellData(scope.row, column.prop)"
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      @focus="selectValue($event)"
                    /> -->
                    <t-input-number
                      v-if="editCellData(scope.row, column)"
                      class="cell_input_number cell_input_font_small"
                      :controls="false"
                      :precision="0"
                      :min="0"
                      :max="99999"
                      width="100%"
                      v-model="scope.row[column.prop]"
                      @blur="changeCellData(scope.row, column.prop)"
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      @focus="selectValue($event)"
                    />
                    <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                    <!-- @change="changeCellData(scope.row, column.prop)"-->
                    <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                    <!-- <t-input
                      v-else-if="
                        column.prop === 'jrdRemarks' &&
                        scope.row.jrdUpdFlg !== '1'
                      "
                      maxLength="200"
                      v-model="scope.row[column.prop]"
                      :disabled="scope.row.jrdUpdFlg === '1'"
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      @focus="selectValue($event)"
                    /> -->
                    <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->

                    <!-- 外観检查  -->
                    <!-- <t-checkbox
                      v-else-if="column.prop === 'jrdAppearanceCheck'"
                      v-model="scope.row['jrdAppearanceCheckBool']"
                      :disabled="
                        scope.row.jrdUpdFlg === '1' ||
                        scope.row.crdAppearanceCheck === '1'
                      "
                    ></t-checkbox> -->

                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template>
                </t-table-column>
                <!-- ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 start↓ -->
                <t-table-column
                  :label="$t('resource.DUE_DATE_EDIT.TREATMENT')"
                  :class-name="'cell_txt_center input_font_small'"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!--異常製品追加-->
                    <!-- UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓ -->
                    <!-- <t-button
                      type="primary"
                      size="small"
                      style="
                        flex-shrink: 0;
                        width: 100px;
                        display: inline-block;
                      "
                      :disabled="localIsAdd"
                      @click="
                        showDueDateEditDialogBeforeProc(scope.row, $event)
                      "
                    > -->
                    <t-button
                      type="primary"
                      size="small"
                      style="
                        flex-shrink: 0;
                        width: 100px;
                        display: inline-block;
                      "
                      :disabled="localIsAdd || scope.row.jrdUpdFlg === '1'"
                      @click="
                        showDueDateEditDialogBeforeProc(scope.row, $event)
                      "
                    >
                      <!-- UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑ -->
                      {{ $t("resource.DUE_DATE_EDIT.ERR_PROD_ADD") }}</t-button
                    >
                  </template>
                </t-table-column>
                <!-- ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 end↑ -->
                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_備考機能の追加 -->
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- 共通備考の調整 -->
                <!--<t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  :min-width="100"
                  :class-name="'cell_txt_center input_font_small'"
                >
                  <template slot-scope="scope">
                    <div class="button-container">
                      <t-tooltip placement="bottom" effect="light">
                        <div
                          slot="content"
                          class="tooltip-content"
                          v-html="
                            formatRemarksShowProc(scope.row.aodProdRemarksSum)
                          "
                        ></div>
                        <t-button
                          :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                          icon="el-icon-search"
                          size="small"
                          circle
                        >
                        </t-button>
                      </t-tooltip>
                      <t-button
                        type="warning"
                        icon="el-icon-edit"
                        size="small"
                        circle
                        @click="addRemarksProd(scope.row, $event)"
                      ></t-button>
                    </div>
                  </template>
                </t-table-column> -->
                <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  prop="aodProdRemarksSum"
                  :class-name="'cell_txt_center input_font_small'"
                  :width="getRemarksColumnWidthProc()"
                >
                  <template slot-scope="scope">
                    <div class="bikouDiv">
                      <!-- 備考表示 -->
                      <span class="bikouText">
                        {{ scope.row.aodProdRemarksSum }}
                      </span>
                      <!-- 備考編集 -->
                      <t-button
                        type="warning"
                        icon="el-icon-edit"
                        size="small"
                        class="bikouButton"
                        circle
                        @click="showRemarksDialogProc(scope.row, $event)"
                      ></t-button>
                    </div>
                  </template>
                </t-table-column>
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right">
          <t-row>
            <div>
              <!-- DEL 2025/07/01 Wjx 課題_数量·納期調整機能の追加 start↓ -->
              <!-- 課題_納期分割機能の追加 -->
              <!-- <t-col :span="20" class="left">
                <t-button
                  round
                  type="primary"
                  class="dialogButton_150_40"
                  @click="jpReceRequestAgainDialog"
                  :disabled="receAgainFlg"
                >
                  <i class="el-icon-s-order"></i>
                  {{ $t("resource.JP_RECEIVE.RECE_AGAIN") }}</t-button
                >
              </t-col> -->
              <!-- DEL 2025/07/01 Wjx 課題_数量·納期調整機能の追加 end↑ -->
              <t-col :span="24" class="right">
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  ref="confirmBtn"
                  :disabled="confirmBtnFlg"
                  @click="jpReceConfirm"
                >
                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import {
  ShowDueDateEditDialog,
  ShowJpReceDLSelectDialog,
  ShowJpReceRequestAgainDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import { showRemarksDialog, showRemarksUpdDialog } from "@/services/common";
import {
  addJpReceDetail,
  getJpReceInitList,
  searchJpReceDetailByReceNo,
  searchJpReceTransSelect,
  updateJpReceDetail,
} from "@/services/jpReceive";
import {
  cmpBasicData,
  cmpDetailDataExceptRemarks,
  formatCurDateToString,
  formatRemarksShow,
  getAbleUserInfoList,
  getEditColWidthArr,
  getIconType,
  getRemarksColumnWidth,
  ShowMergeExKbn,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  NORMAL_PROD,
  NUM_ONE,
  NUM_ZERO,
  STR_EMPTY,
  STR_FOUR,
  STR_ONE,
  STR_ZERO,
} from "@/utils/const";
import { flexColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      activeNames: ["receDLBasic"],
      // 支払状態
      PayStatusList: [],

      // 状態
      jrbReceStatusList: [],

      //運送台帳選択ボタンが使用可
      transSelectFlg: false,

      //再入荷申請ボタンが使用不可
      receAgainFlg: true,
      //入荷チェックリスト出力ボタンが使用不可
      outPutClickFlg: true,

      //確定ボタンの使用フラグ
      confirmBtnFlg: true,

      //連絡担当
      connecterList: [],

      //異常区分
      prodExKbnList: [],
      //仕入先リスト
      // supCodeList: [],

      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_備考機能の追加
      // editableColumns: ["jrdReceQty", "jrdReceNgQty", "jrdRemarks"],
      // UPD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 start↓
      //editableColumns: ["jrdReceQty", "jrdReceNgQty"],
      editableColumns: ["jrdReceQty"],
      // UPD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 end↑

      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      jpReceEditForm: {
        jrbReceNo: "", //入荷No
        jrbTransOrderNo: "", // 運送番号（画面)
        jrbTransNo: "", // 運送No.
        jrbDepartureDateOnly: "", // 出発日(読み取り用)
        jrbDepartureDate: "", // 出発日(保存用)
        jrbReceDateOnly: "", // 入荷日(読み取り用)
        jrbReceDate: "", // 入荷日(保存用)
        jrbUserCode: "", // 連絡担当
        jrbReceStatus: "", // 状態
        jrbFactoryKbn: "", // 工場
        jrbSupCode: "", // 仕入先

        jrbPayStatus: "", // 支払状態
        jrbRemarks: "", // 備考

        jrbUpdateTime: "", // 更新時刻
        jrbUpdateUser: "", // 更新者
      },

      isSelected: false,

      //入荷運送選択情報
      jrbReceInfoTable: [],
      //運送選択情報
      transSelectData: [],

      maxheight: t("widgetSize.TRANSPORT_EDIT_DIALOG.HEIGHT_TABLE"),
      //テーブルの列
      columns: [
        {
          // 仕入先
          prop: "jrbSupCodeShow",
          label: t("resource.JP_RECEIVE.SUPPLIER_COMPANY"),
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          //画面と文字サイズの調整
          // width: 150,
          width: 120,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 検査室入荷日
        /*
        {
          prop: "crbReceDateOnly",
          label: t("resource.JP_RECEIVE.CHECK_RCV_DATE"),
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 120,
          class: "cell_txt_center",
        },*/
        // 仕入先納期
        {
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //prop: "obDueDateOnly",
          prop: "odDueDateOnly",
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          label: t("resource.JP_RECEIVE.SUPPLIER_DUE_DATE"),
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: 120,
          width: 100,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_center",
        },

        // 品名
        {
          prop: "aodProdName",
          label: t("resource.JP_RECEIVE.PRODUCT_NAME"),
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: 150,
          width: 120,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.JP_RECEIVE.PRODUCT_DRAW_NO"),
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: 150,
          width: 120,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.JP_RECEIVE.PRODUCT_UNIT"),
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: 80,
          width: 60,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_center",
        },

        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
        // // 素材
        // {
        //   prop: "aodProdMaterial",
        //   label: t("resource.JP_RECEIVE.PRODUCT_MATERIAL"),
        //   width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // // 処理
        // {
        //   prop: "aodProdTreatment",
        //   label: t("resource.JP_RECEIVE.PRODUCT_TREAT"),
        //   width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑
        // 注文数
        {
          prop: "odProdQuantity",
          label: t("resource.JP_RECEIVE.PRODUCT_COUNT"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 60,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },

        // 入荷済み数
        {
          prop: "aodProCompleteNum",
          label: t("resource.JP_RECEIVE.RECE_COMPLETE_QUANTITY"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },

        // 運送数
        {
          prop: "jrdReceQty",
          label: t("resource.JP_RECEIVE.TRANSPORT_NUM"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 80,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        // 入荷OK数
        {
          prop: "jrdReceOkQty",
          label: t("resource.JP_RECEIVE.RECE_OK_QUANTITY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 80,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },
        // 入荷NG数
        {
          prop: "jrdReceNgQty",
          label: t("resource.JP_RECEIVE.RECE_NG_QUANTITY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 80,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },

        // 入荷残
        {
          prop: "jrdReceRemainQty",
          label: t("resource.JP_RECEIVE.RECE_REMAIN_QUANTITY"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 60,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_right",
        },

        // // 外観検査
        // {
        //   prop: "jrdAppearanceCheck",
        //   label: t("resource.JP_RECEIVE.APPEARANCE_CHECK"),
        //   width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_center",
        // },

        // 異常区分
        {
          prop: "jrdProdExKbnShow",
          label: t("resource.JP_RECEIVE.ABNORMAL_DIFFERENCE"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 80,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_center",
        },
        // 注文No
        {
          prop: "jrdOrderNoShow",
          label: t("resource.JP_RECEIVE.ORDER_NO"),
          // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 画面と文字サイズの調整
          // width: 170,
          width: 130,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          class: "cell_txt_left",
        },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // 備考
        // {
        //   prop: "jrdRemarks",
        //   label: t("resource.JP_RECEIVE.REMARKS"),
        //   // width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   width: 180,
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      ],

      localIsAdd: this.isAdd,

      editDisableFlg: true,

      //運送製品選択画面の検索条件
      selectedSearchConditionForm: [],

      //運送明細情報(保存用)
      jpReceDetailInfo: [],

      showFlag: false,

      //基本情報のheight
      basicHeight: 49 + 45 + 45 + 65 + 45,
      // 明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 画面と文字サイズの調整
      // detailHeight:
      //   window.innerHeight * (1 - 0.1) -
      //   65 -
      //   (49 + 45 + 45 + 65 + 45) -
      //   DIALOG_LINE_HEIGHT -
      //   25,
      detailHeight:
        window.innerHeight * 0.99 -
        65 -
        (49 + 45 + 45 + 65 + 45) -
        DIALOG_LINE_HEIGHT -
        25,
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT,
      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 4),

      // 読み込み回数
      numLoads: 1,

      // 比較用基本情報
      cmpBasicResult: {},

      // 比較用明細情報
      cmpDetailResult: {},

      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 共通備考の調整（備考更新時刻）
      aodUpdateTime: null,
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

      // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
      // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する
      // 検索キー
      searchWord: "",
      // 一覧情報（画面表示）
      filteredDetailTable: [],
      // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    basicData: {
      Type: Object,
      default: null,
    },
  },

  // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
  // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する
  watch: {
    filteredDetailTable: {
      handler(newVal) {
        this.jrbReceInfoTable = this.jrbReceInfoTable.map((originalItem) => {
          const matchedItem = newVal.find(
            (item) =>
              item.jrdOrderNo === originalItem.jrdOrderNo &&
              item.jrdDetailNo === originalItem.jrdDetailNo &&
              item.jrdProdExKbn === originalItem.jrdProdExKbn
          );
          return matchedItem ? { ...matchedItem } : originalItem;
        });
      },
      deep: true,
    },
  },
  // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑

  mounted() {
    this.init(this.basicData);
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
    // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する

    //クリア処理
    handleClear() {
      this.$refs.searchInput = "";
      this.searchWord = "";
      this.handleSearchChange();
    },
    // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑

    //折り畳みパネルの処理
    handleCollapseChange(val) {
      this.handleResize(val);
    },

    //テーブルの高さを設定する
    handleResize(val) {
      var val = this.activeNames;

      if (val.indexOf("receDLBasic") !== -1) {
        this.basicHeight = 49 + 45 + 45 + 65 + 45;

        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 画面と文字サイズの調整
        // this.detailHeight =
        //   window.innerHeight * (1 - 0.1) -
        //   65 -
        //   (49 + 45 + 45 + 65 + 45) -
        //   DIALOG_LINE_HEIGHT -
        //   25;
        this.detailHeight =
          window.innerHeight * 0.99 -
          65 -
          (49 + 45 + 45 + 65 + 45) -
          DIALOG_LINE_HEIGHT -
          25;
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      } else {
        this.basicHeight = 49 + 45;

        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 画面と文字サイズの調整
        // this.detailHeight =
        //   window.innerHeight * (1 - 0.1) -
        //   65 -
        //   (49 + 45) -
        //   DIALOG_LINE_HEIGHT -
        //   20;
        this.detailHeight =
          window.innerHeight * 0.99 - 65 - (49 + 45) - DIALOG_LINE_HEIGHT - 20;
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      }

      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },

    // 初期化
    init(data) {
      this.showFlag = true;
      ///基本情報のリスト取得（仕入先、担当者）
      getJpReceInitList()
        .then((res) => {
          //連絡担当リストの取得
          this.connecterList = res.jrbUserList;
          //支払状態
          this.PayStatusList = res.jrbPayStatusList;
          //日本入荷状態
          this.jrbReceStatusList = res.jrbStatusList;
          //異常区分
          this.prodExKbnList = res.prodExKbnList;
          //初期値の設定
          this.setInitValue(data);
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        });

      // 列幅に自動調整
      // setColumnWidth(this.columns, this.jrbReceInfoTable);
    },

    //初期値の設定
    setInitValue(data) {
      //新規作成の場合
      if (this.localIsAdd) {
        this.activeNames = ["receDLBasic"];
        this.handleCollapseChange(this.activeNames);

        // 入荷日:システム日
        this.jpReceEditForm.jrbReceDateOnly = new Date();
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_入荷状態の改善
        // 状態：新規
        // this.jpReceEditForm.jrbReceStatus = STR_ONE;
        this.jpReceEditForm.jrbReceStatus = STR_EMPTY;
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        // 支払状態
        this.jpReceEditForm.jrbPayStatus = STR_ONE;
        // 連絡担当
        this.jpReceEditForm.jrbUserCode = getUserInfo().UserId;
        this.getAbleList();

        this.transSelectFlg = false;
        this.showFlag = false;
      } else {
        this.activeNames = [""];
        this.handleCollapseChange(this.activeNames);

        this.jpReceEditForm = data;

        //日本入荷No.による日本入荷詳細情報の取得
        this.getJpReceDetailByReceNo();
        // 再入荷申請ボタンが使用可
        this.receAgainFlg = false;
        //入荷チェックリスト出力ボタンが使用可
        this.outPutClickFlg = false;

        //確定ボタンが使用可能に変更
        this.confirmBtnFlg = false;
      }
    },

    // 使用可能な担当者リストの取得
    getAbleList() {
      // 担当者リスト
      this.connecterList = getAbleUserInfoList(
        this.connecterList,
        this.jpReceEditForm.jrbUserCode
      );
    },

    //日本入荷No.による日本入荷詳細情報の取得
    getJpReceDetailByReceNo() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      searchJpReceDetailByReceNo({ jrbReceNo: this.jpReceEditForm.jrbReceNo })
        .then((res) => {
          //*****UserCode正しくない */
          this.jpReceEditForm = res.jpReceBasicInfo;
          this.jrbReceInfoTable = res.jpReceDetailInfoList;
          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
          // 運送数量の保存履歴
          this.transSelectData = JSON.parse(
            JSON.stringify(res.jpReceDetailInfoList)
          );
          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          // 共通備考の調整（備考更新時刻）
          if (
            res.jpReceDetailInfoList != null &&
            res.jpReceDetailInfoList.length != 0
          ) {
            this.aodUpdateTime = res.jpReceDetailInfoList[0].aodUpdateTime;
          }

          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
          this.getAbleList();
          //仕入先支払データ存在する区分
          let payExistFlg = this.jrbReceInfoTable.some(
            (item) => item.jrdUpdFlg === STR_ONE
          );

          // 仕入先支払データ存在の場合、ボタンは使用できません
          if (payExistFlg) {
            this.transSelectFlg = true;
          } else {
            this.transSelectFlg = false;
          }
          this.dataProcess();

          // 列幅に自動調整
          // setColumnWidth(this.columns, this.jrbReceInfoTable);

          // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
          // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する
          // 発送予定一覧選択情報（画面表示）
          this.handleSearchChange();
          // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //データの処理
    dataProcess() {
      let detailResult = [];
      this.jrbReceInfoTable.map((item, index) => {
        if (!item.jrdUpdFlg) {
          item.jrdUpdFlg = STR_ZERO;
        }

        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        item.jrdProdExKbnShow = ShowMergeExKbn(
          item.jrdProdExKbn,
          item.jrdProdReceExKbn
        );
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        // 入荷数
        item.jrdReceQty = this.checkNull(item.jrdReceQty);
        // 入荷NG数
        item.jrdReceNgQty = this.checkNull(item.jrdReceNgQty);
        // 入荷OK数: 入荷数 - 入荷NG数
        item.jrdReceOkQty = item.jrdReceQty - item.jrdReceNgQty;
        // 入荷残 = 注文数 - 入荷済み数 - 入荷OK数
        item.jrdReceRemainQty =
          item.odProdQuantity - item.aodProCompleteNum - item.jrdReceOkQty;

        item.index = index;
        detailResult.push(item);

        return item;
      });

      // 読み込み回数 = 1
      if (!this.localIsAdd && this.numLoads == 1) {
        // 比較用基本情報
        this.cmpBasicResult = JSON.parse(
          JSON.stringify(this.extractBasic(this.jpReceEditForm))
        );

        // 比較用明細情報
        this.cmpDetailResult = JSON.parse(JSON.stringify(detailResult));

        // 読み込み回数 + 1
        this.numLoads = this.numLoads + 1;
      }
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },

    //「確定」ボタン
    jpReceConfirm() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();

      for (let index = 0; index < this.jrbReceInfoTable.length; index++) {
        const element = this.jrbReceInfoTable[index];

        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        //入荷残<0
        // if (element.jrdReceRemainQty < 0 || element.jrdReceQty <= 0) {
        //   // let min = NUM_ONE;
        //   // let max = element.odProdQuantity - element.aodProCompleteNum;
        //   let message =
        //     "製品「" +
        //     element.aodProdName +
        //     "」の" +
        //     t("message.JP_RECEIVE.TRANS_QTY_CHECK");
        //   // let targetMessage = message
        //   //   .replace(/\$\{min\}/g, min.toString())
        //   //   .replace(/\$\{max\}/g, max.toString());
        //   Modal.showWarning("", message, {
        //     confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //   });
        //   return;

        //入荷数<0
        if (element.jrdReceQty <= 0) {
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.JP_RECEIVE.TRANS_QTY_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        }
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        //入荷OK数<0
        if (element.jrdReceQty - element.jrdReceNgQty < 0) {
          // let min = NUM_ZERO;
          // let max = element.jrdReceQty;
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.JP_RECEIVE.NG_QTY_CHECK");
          // let targetMessage = message
          //   .replace(/\$\{min\}/g, min.toString())
          //   .replace(/\$\{max\}/g, max.toString());
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        }

        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        //　運送数＜手配数 + ng数　のチェック
        if (
          element.jrdReceQty >
          element.odProdQuantity + element.jrdReceNgQty
        ) {
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.JP_RECEIVE.TRANS_QTY_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        }
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
      }

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // if (this.jrbReceInfoTable.length >= NUM_ONE) {
      //   if (this.localIsAdd) {
      //     //日本入荷台帳新規作成
      //     this.addJpReceDetailProc();
      //   } else {
      //     //日本入荷台帳編集保存
      //     this.updateJpReceDetailProc();
      //   }
      // } else {
      //   Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
      //     confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
      //   });
      // }

      // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
      // //入荷残<0
      // let rcvRemainQtyCheckFlg = this.jrbReceInfoTable.some(function (item) {
      //   return item.jrdReceRemainQty < 0;
      // });
      // if (rcvRemainQtyCheckFlg) {
      //   let message = t("message.JP_RECEIVE.RCV_QTY_REMAIN_CONFIRM");

      //   Modal.showWarning("", message, {
      //     $type: "prompt",
      //     confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
      //     cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
      //     showCancelButton: true,
      //   })
      //     .then(() => {
      //       this.saveDataProc();
      //     })
      //     .finally(() => {
      //       if (this.showFlag) {
      //         this.showFlag = false;
      //       }
      //     });
      // } else {
      //   this.saveDataProc();
      // }
      // 運送数の変更のチェック
      const isAllSame = !this.jrbReceInfoTable.some((r) =>
        this.transSelectData.some(
          (t) =>
            t.jrdOrderNo === r.jrdOrderNo &&
            t.jrdDetailNo === r.jrdDetailNo &&
            t.jrdReceQty !== r.jrdReceQty
        )
      );
      // const isAllSame = true;
      // for (let index = 0; index < this.jrbReceInfoTable.length; index++) {
      //   const element = this.jrbReceInfoTable[index];
      //   for (let sonIndex = 0; sonIndex < this.transSelectData.length; sonIndex++) {
      //     const sonElement = this.transSelectData[sonIndex];

      //     if (element.jrdOrderNo === sonElement.jrdOrderNo &&
      //         element.jrdDetailNo === sonElement.jrdDetailNo
      //       ) {

      //       if (element.jrdReceQty != sonElement.jrdReceQty) {
      //         isAllSame = false;
      //       }
      //     }
      //   }

      // }

      if (!isAllSame) {
        let message = t("message.JP_RECEIVE.TRANS_QTY_CHANGE_CHECK");
        Modal.showWarning("", message, {
          $type: "prompt",
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          showCancelButton: false,
        })
          .then(() => {
            this.saveDataProc();
          })
          .finally(() => {
            if (this.showFlag) {
              this.showFlag = false;
            }
          });
      } else {
        this.saveDataProc();
      }
      // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    saveDataProc() {
      if (this.jrbReceInfoTable.length >= NUM_ONE) {
        if (this.localIsAdd) {
          //日本入荷台帳新規作成
          this.addJpReceDetailProc();
        } else {
          //日本入荷台帳編集保存
          this.updateJpReceDetailProc();
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    //再入荷申請確認画面
    jpReceRequestAgainDialog() {
      var data = this.receAgainDataProcess();

      if (data == "") {
        // 入荷NG数<0の場合
        Modal.showWarning("", t("message.JP_RECEIVE.NO_NG_CHECK"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return;
      }
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      //データ保存
      // this.jpReceConfirm();

      for (let index = 0; index < this.jrbReceInfoTable.length; index++) {
        const element = this.jrbReceInfoTable[index];

        //入荷残<0
        // if (element.jrdReceRemainQty < 0 || element.jrdReceQty <= 0) {
        //   // let min = NUM_ONE;
        //   // let max = element.odProdQuantity - element.aodProCompleteNum;
        //   let message =
        //     "製品「" +
        //     element.aodProdName +
        //     "」の" +
        //     t("message.JP_RECEIVE.TRANS_QTY_CHECK");
        //   // let targetMessage = message
        //   //   .replace(/\$\{min\}/g, min.toString())
        //   //   .replace(/\$\{max\}/g, max.toString());
        //   Modal.showWarning("", message, {
        //     confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //   });
        //   return;

        //   ShowJpReceRequestAgainDialog(
        //   {
        //     receAgainData: data,
        //   },
        //   t("resource.JP_RECEIVE.AGAIN_RECE_DIALOG"),

        //   (target) => {
        //     if (!!target) {
        //       // setColumnWidth(this.columns, this.jrbReceInfoTable);
        //     }
        //   }
        // );

        //入荷数<0
        if (element.jrdReceQty <= 0) {
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.JP_RECEIVE.TRANS_QTY_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        }

        //入荷OK数<0
        if (element.jrdReceQty - element.jrdReceNgQty < 0) {
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.JP_RECEIVE.NG_QTY_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        }
      }

      //入荷残<0
      let rcvRemainQtyCheckFlg = this.jrbReceInfoTable.some(function (item) {
        return item.jrdReceRemainQty < 0;
      });
      if (rcvRemainQtyCheckFlg) {
        let message = t("message.JP_RECEIVE.RCV_QTY_REMAIN_CONFIRM");

        Modal.showWarning("", message, {
          $type: "prompt",
          confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
          cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
          showCancelButton: true,
        })
          .then(() => {
            this.saveDataProc();
            // 再入荷申請確認画面を表示する
            this.ShowJpReceRequestAgainDialog(data);
          })
          .finally(() => {
            if (this.showFlag) {
              this.showFlag = false;
            }
          });
      } else {
        this.saveDataProc();
        // 再入荷申請確認画面を表示する
        this.ShowJpReceRequestAgainDialog(data);
      }
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // 再入荷申請確認画面を表示する
    ShowJpReceRequestAgainDialog(data) {
      ShowJpReceRequestAgainDialog(
        {
          receAgainData: data,
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          receAgainDataBasic: this.jpReceEditForm,
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        },
        t("resource.JP_RECEIVE.AGAIN_RECE_DIALOG"),

        (target) => {
          if (!!target) {
            // setColumnWidth(this.columns, this.jrbReceInfoTable);
          }
        }
      );
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    //再入荷申請データの処理
    receAgainDataProcess() {
      var data = [];
      for (let index = 0; index < this.jrbReceInfoTable.length; index++) {
        const element = this.jrbReceInfoTable[index];
        //入荷NG数>0の場合
        if (element.jrdReceNgQty > NUM_ZERO) {
          data.push(element);
        }
      }
      return data;
    },

    // 入荷詳細情報の更新
    updateJpReceDetailProc() {
      this.dataAddUpdProc();
      updateJpReceDetail({
        jpReceBasicInfo: this.jpReceEditForm,
        jpReceDetailInfoList: this.jpReceDetailInfo,
      })
        .then((res) => {
          this.numLoads = 1;
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          //検索処理を行う
          this.getJpReceDetailByReceNo();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            // ADD 2026/08/25 Wjx 重複有無チェックとログの追加「日本入荷」 start↓
            if (err.data.Messages[0].Message == "P06_W008") {
              Modal.showWarning("", t("message.COMMON_MESSAGE.P06_W008"), {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              });
              return false;
            } else {
              // ADD 2026/08/25 Wjx 重複有無チェックとログの追加「日本入荷」 end
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            }
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        });
      // .finally(() => {
      //   //検索処理を行う
      //   this.getJpReceDetailByReceNo();
      // });
    },

    //入荷明細情報の追加
    addJpReceDetailProc() {
      //保存前、データ処理
      this.dataAddUpdProc();

      addJpReceDetail({
        jpReceBasicInfo: this.jpReceEditForm,
        jpReceDetailInfoList: this.jpReceDetailInfo,
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
          this.localIsAdd = false;
          // 再入荷申請ボタンが使用可
          this.receAgainFlg = false;
          //入荷チェックリスト出力ボタンが使用可
          this.outPutClickFlg = false;
          this.jpReceEditForm.jrbReceNo = res;
          //検索処理を行う
          this.getJpReceDetailByReceNo();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            // ADD 2026/08/25 Wjx 重複有無チェックとログの追加「日本入荷」 start↓
            if (err.data.Messages[0].Message == "P06_W007") {
              Modal.showWarning("", t("message.COMMON_MESSAGE.P06_W007"), {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              });
              return false;
            } else {
              // ADD 2026/08/25 Wjx 重複有無チェックとログの追加「日本入荷」 end
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            }
          } else {
            Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
          }
        });
      //     .finally(() => {
      //       //検索処理を行う
      //       this.getJpReceDetailByReceNo();
      //     });
    },

    // 更新/追加されたデータ処理
    dataAddUpdProc() {
      // 出発日
      this.jpReceEditForm.jrbDepartureDate = formatCurDateToString(
        this.jpReceEditForm.jrbDepartureDateOnly
      );

      // 入荷日
      this.jpReceEditForm.jrbReceDate = formatCurDateToString(
        this.jpReceEditForm.jrbReceDateOnly
      );

      this.jpReceEditForm.jrbUpdateUser = getUserInfo().UserId;
      this.jpReceEditForm.jrbFactoryKbn = STR_ONE;

      // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_入荷状態の改善
      if (
        this.jpReceEditForm.jrbReceStatus === undefined ||
        this.jpReceEditForm.jrbReceStatus === null ||
        this.jpReceEditForm.jrbReceStatus === STR_EMPTY ||
        !this.jpReceEditForm.jrbReceStatus
      ) {
        this.jpReceEditForm.jrbReceStatus = this.jrbReceStatusList[0]?.value;
      }
      // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      this.jpReceDetailInfo = this.jrbReceInfoTable;
      for (let index = 0; index < this.jpReceDetailInfo.length; index++) {
        const element = this.jpReceDetailInfo[index];
        this.jpReceDetailInfo[index].jrdReceNo = this.jpReceEditForm.jrbReceNo; // 入荷No
        this.jpReceDetailInfo[index].jrdReceDetailNo = index + 1; // 入荷明細No
        // this.jpReceDetailInfo[index].jrdAppearanceCheck =
        //   element.jrdAppearanceCheckBool ? 1 : 0; // 外観検査
        if (!this.jpReceDetailInfo[index].jrdPayStatus && this.localIsAdd) {
          this.jpReceDetailInfo[index].jrdPayStatus = STR_ONE;
        }
      }
    },

    //セルデータの編集
    editCellData(row, column) {
      //仕入先支払の日本入荷情報編集不可
      // // 外観検査
      // if (column.prop === "jrdAppearanceCheck") {
      //   return false;
      // }

      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_備考機能の追加
      // // 備考
      // if (column.prop === "jrdRemarks") {
      //   return false;
      // }
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      if (!this.editableColumns.includes(column.prop)) {
        return false;
      }

      if (this.localIsAdd) {
        return true;
      }

      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      //入荷したの入荷異常データの場合、NG数入力不可
      if (row.jrdErrFlg === STR_ONE && column.prop === "jrdReceNgQty") {
        return false;
      }
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      if (row.jrdUpdFlg === STR_ONE && row.jrdUpdFlg) {
        return false;
      }

      return true;
    },

    //列幅に自動調整
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.jrbReceInfoTable);
    },

    // 運送製品選択画面を表示
    jpReceDLSelectDialog() {
      // フォーカス削除
      this.$refs.jpReceDLSelectBtn.$el.blur();

      ShowJpReceDLSelectDialog(
        {},
        t("resource.JP_RECEIVE.TRANSPORT_SELECT_DIALOG"),

        (target) => {
          if (!!target) {
            searchJpReceTransSelect({
              tbTransNo: target,
            })
              .then((res) => {
                var result = res.jpReceDetailInfoList;
                if (!!result) {
                  //運送No
                  this.jpReceEditForm.jrbTransOrderNo =
                    result[0].tbTransOrderNo;
                  this.jpReceEditForm.jrbTransNo = result[0].tbTransNo;
                  this.jpReceEditForm.jrbDepartureDateOnly =
                    result[0].tbDepartureDateOnly;
                  this.jpReceEditForm.tbDepartureDate =
                    result[0].tbDepartureDate;

                  let jrbReceInfoTable = this.jrbReceInfoTable;
                  let jrbReceTableSelect = result;

                  jrbReceTableSelect.forEach((item) => {
                    let existingProductIndex = jrbReceInfoTable.findIndex(
                      (p) =>
                        p.jrdOrderNo == item.jrdOrderNo &&
                        p.jrdDetailNo == item.jrdDetailNo
                    );

                    if (existingProductIndex == -1) {
                      item.jrdReceOkQty = item.jrdReceQty;

                      if (!item.jrdUpdFlg) {
                        item.jrdUpdFlg = STR_ZERO;
                      }

                      if (!item.jrdReceNgQty) {
                        item.jrdReceNgQty = NUM_ZERO;
                      }
                      if (!item.jrdReceRemainQty) {
                        item.jrdReceRemainQty = NUM_ZERO;
                      }
                      this.jrbReceInfoTable.push(item);
                    }
                  });

                  this.jrbReceInfoTable = this.jrbReceInfoTable.filter((p) =>
                    jrbReceTableSelect.some(
                      (t) =>
                        p.jrdOrderNo == t.jrdOrderNo &&
                        p.jrdDetailNo == t.jrdDetailNo
                    )
                  );

                  // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                  // 運送数量の保存履歴
                  this.transSelectData = [];
                  this.transSelectData = JSON.parse(
                    JSON.stringify(this.jrbReceInfoTable)
                  );
                  // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

                  this.dataProcess();
                  // setColumnWidth(this.columns, this.jrbReceInfoTable);

                  //確定ボタンが使用可能に変更
                  this.confirmBtnFlg = false;

                  // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
                  // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する
                  // 一覧情報（画面表示）
                  this.handleSearchChange();
                  // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑
                }
              })
              .catch((err) => {
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(
                    t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
                  );
                }
              });
          }
        }
      );
    },

    // 「運送製品リスト出力」ボタン
    OutPutClick() {
      this.$message("「運送製品リスト出力」ボタン");
    },

    //セルデータの保存
    changeCellData(row, column) {
      if (!row.jrdUpdFlg) {
        row.jrdUpdFlg = STR_ZERO;
      }

      row.jrdReceQty = this.checkNull(row.jrdReceQty);
      row.jrdReceNgQty = this.checkNull(row.jrdReceNgQty);
      row.aodProCompleteNum = this.checkNull(row.aodProCompleteNum);
      // 入荷NG数: 入荷数 - 入荷OK数
      row.jrdReceOkQty = row.jrdReceQty - row.jrdReceNgQty;
      // 入荷残 = 注文数 - 入荷済み数 - 入荷OK数
      row.jrdReceRemainQty =
        row.odProdQuantity - row.aodProCompleteNum - row.jrdReceOkQty;
      this.$set(this.jrbReceInfoTable, row.index, row);
      // setColumnWidth(this.columns, this.jrbReceInfoTable);
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      let columnIndex = this.editableColumns.indexOf(columnProp);

      if (columnIndex == -1) {
        columnIndex = 0;
      }

      index = index + 1;

      if (index > this.jrbReceInfoTable.length - 1) {
        this.$refs[`input${0}`][columnIndex].focus();
      } else {
        this.$refs[`input${index}`][columnIndex].focus();
      }
    },

    checkNull(val) {
      if (!!!val || val === "" || typeof val === "undefined") {
        val = 0;
      }
      return val;
    },

    // チェックボックスの選択
    handleCheckboxChange(row, column) {
      if (row.jrdUpdFlg === STR_ONE) {
        return;
      }
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      var columnEditable = [
        "jrdReceQty",
        // DEL 2025/07/01 Wjx 課題_数量·納期調整機能の追加 start↓
        //"jrdReceNgQty",
        // DEL 2025/07/01 Wjx 課題_数量·納期調整機能の追加 end↑
        // "jrdAppearanceCheck",
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // "jrdRemarks",
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      ];

      if (
        columnEditable.includes(column.property) ||
        (column.property && column.property.toString().includes("newColumn"))
      ) {
        if (this.localIsAdd && column.property !== "jrdAppearanceCheck") {
          return "bg-cell-editable";
        }

        // if (
        //   column.property == "jrdAppearanceCheck" &&
        //   row.crdAppearanceCheck !== STR_ONE &&
        //   row.jrdUpdFlg !== STR_ONE
        // ) {
        //   //編集可能の背景色
        //   return "bg-cell-editable";
        // }

        if (row.jrdUpdFlg !== STR_ONE) {
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          if (row.jrdErrFlg === STR_ONE && column.property === "jrdReceNgQty") {
            return;
          }
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
          //編集可能の背景色
          return "bg-cell-editable";
        }
      }
    },

    // 製品異常
    rowClassName({ row }) {
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      // if (row.jrdProdExKbnShow === PROD_EX_SEND) {
      if (row.jrdProdExKbnShow !== NORMAL_PROD) {
        // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        return "textColor";
      }
    },

    extractBasic(data) {
      return {
        jrbReceDateOnly: data.jrbReceDateOnly,
        jrbUserCode: data.jrbUserCode,
        jrbReceStatus: data.jrbReceStatus,
        jrbRemarks: data.jrbRemarks,
      };
    },

    // ダイアログを閉じる
    onCancel() {
      let isDataChanged = false;
      if (this.localIsAdd) {
        isDataChanged = this.jrbReceInfoTable.length > 0;
      } else {
        const extractedBasic = this.extractBasic(this.jpReceEditForm);

        // const extractedDetails = this.extractDetails(this.creDetailInfoTable);
        isDataChanged =
          !cmpBasicData(this.cmpBasicResult, extractedBasic) ||
          // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          // !cmpDetailData(this.cmpDetailResult, this.jrbReceInfoTable);
          !cmpDetailDataExceptRemarks(
            this.cmpDetailResult,
            this.jrbReceInfoTable,
            // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
            // ["aodProdRemarksSum", "aodProdRemarks"]

            // UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
            // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する
            //["aodProdRemarksSum", "aodProdRemarks", "aodUpdateTime"]
            ["aodProdRemarksSum", "aodProdRemarks", "aodUpdateTime", "index"]
            // UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑

            // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
          );
        // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
      }

      if (isDataChanged) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // 入力ボックスをクリックの場合、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    addRemarksProd(row, event) {
      // フォーカス削除
      event.currentTarget.blur();

      if (!this.showFlag) {
        this.showFlag = true;
      }
      let remarks = STR_EMPTY;
      showRemarksUpdDialog(
        this,
        row.jrdQuoteNo,
        row.jrdProdNo,
        row.aodProdRemarksSum
      )
        .then((res) => {
          remarks = res;
        })

        .finally(() => {
          this.numLoads = 1;

          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
          if (remarks != STR_EMPTY) {
            //　比較用明細情報の備考を変更する
            if (this.cmpDetailResult.length > 0) {
              this.cmpDetailResult.forEach((item) => {
                // 手配NO.と手配明細NO.一致の場合、備考を変更する
                if (
                  item.jrdOrderNo === row.jrdOrderNo &&
                  item.jrdDetailNo === row.jrdDetailNo
                ) {
                  item.aodProdRemarksSum = remarks;
                }
              });
            }
            // 備考を更新する
            row.aodProdRemarksSum = remarks;
          }
        });
    },

    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.jrbReceInfoTable);
    },

    //共通備考の調整（備考の表示と保存）
    showRemarksDialogProc(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }
      showRemarksDialog(
        this,
        row.jrdQuoteNo,
        row.jrdProdNo,
        row.aodProdRemarksSum,
        row.aodProdRemarksSum,
        // UPD 2025/08/19 WZC 内部バグ_「複数の見積番号、備考入力保存時に排他メッセージが表示される」問題の修正 start↓
        // this.aodUpdateTime
        row.aodUpdateTime
        // UPD 2025/08/19 WZC 内部バグ_「複数の見積番号、備考入力保存時に排他メッセージが表示される」問題の修正 end↑
      )
        .then((res) => {
          if (!this.isEmptyOrNull(res)) {
            // 備考を更新する
            row.aodProdRemarksSum = res.aodProdRemarks;
            // UPD 2025/08/19 WZC 内部バグ_「複数の見積番号、備考入力保存時に排他メッセージが表示される」問題の修正 start↓
            // this.aodUpdateTime = res.aodUpdateTime;
            row.aodUpdateTime = res.aodUpdateTime;

            this.jrbReceInfoTable
              .filter((item) => item.jrdQuoteNo === row.jrdQuoteNo)
              .forEach((item) => {
                item.aodUpdateTime = row.aodUpdateTime;
              });
            // UPD 2025/08/19 WZC 内部バグ_「複数の見積番号、備考入力保存時に排他メッセージが表示される」問題の修正 end↑
            this.$set(this.jrbReceInfoTable, row.index, row);
          }
        })
        .finally(() => {
          this.numLoads = 1;

          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
        });
    },
    //値がNULLまたはEmptyです
    isEmptyOrNull(item) {
      if (item == undefined || item == STR_EMPTY) {
        return true;
      } else {
        return false;
      }
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
    // ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 start↓
    // 異常製品追加画面
    showDueDateEditDialogBeforeProc(row, event) {
      // フォーカス削除
      event.currentTarget.blur();

      // ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 start↓
      // waiting dialog の追加
      if (!this.showFlag) {
        this.showFlag = true;
      }
      // ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 end↑

      for (let index = 0; index < this.jrbReceInfoTable.length; index++) {
        const element = this.jrbReceInfoTable[index];
        //入荷数<0
        if (element.jrdReceQty <= 0) {
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.JP_RECEIVE.TRANS_QTY_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });

          // ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 start↓
          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
          // ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 end↑
          return;
        }

        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        //入荷OK数<0
        if (element.jrdReceQty - element.jrdReceNgQty < 0) {
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.JP_RECEIVE.NG_QTY_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          // ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 start↓
          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
          // ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 end↑
          return;
        }

        //　運送数＜手配数 + ng数　のチェック
        if (
          element.jrdReceQty >
          element.odProdQuantity + element.jrdReceNgQty
        ) {
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.JP_RECEIVE.TRANS_QTY_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          // ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 start↓
          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
          // ADD 2025/12/24 ZLL 課題_251224顧客からの改善したい点への対応 end↑
          return;
        }
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
      }

      // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
      // //入荷残<0
      // let rcvRemainQtyCheckFlg = this.jrbReceInfoTable.some(function (item) {
      //   return item.jrdReceRemainQty < 0;
      // });
      // if (rcvRemainQtyCheckFlg) {
      //   let message = t("message.JP_RECEIVE.RCV_QTY_REMAIN_CONFIRM");

      //   Modal.showWarning("", message, {
      //     $type: "prompt",
      //     confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
      //     cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
      //     showCancelButton: true,
      //   })
      //     .then(async () => {
      //       this.dataAddUpdProc();
      //       updateJpReceDetail({
      //         jpReceBasicInfo: this.jpReceEditForm,
      //         jpReceDetailInfoList: this.jpReceDetailInfo,
      //       })
      //         .then((res) => {
      //           this.numLoads = 1;
      //           Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
      //           //検索処理を行う
      //           this.getJpReceDetailByReceNo();
      //           // 異常製品追加画面
      //           this.showDueDateEditDialogProc(row);
      //         })
      //         .catch((err) => {
      //           this.showFlag = false;
      //           if (err.data != null) {
      //             Message.showError(
      //               t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
      //             );
      //           } else {
      //             Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
      //           }
      //         });
      //     })
      //     .finally(() => {
      //       if (this.showFlag) {
      //         this.showFlag = false;
      //       }
      //     });
      // 運送数の変更のチェック
      const isAllSame = !this.jrbReceInfoTable.some((r) =>
        this.transSelectData.some(
          (t) =>
            t.jrdOrderNo === r.jrdOrderNo &&
            t.jrdDetailNo === r.jrdDetailNo &&
            t.jrdReceQty !== r.jrdReceQty
        )
      );

      if (!isAllSame) {
        let message = t("message.JP_RECEIVE.TRANS_QTY_CHANGE_CHECK");
        Modal.showWarning("", message, {
          $type: "prompt",
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          showCancelButton: false,
        })
          .then(() => {
            this.dataAddUpdProc();
            updateJpReceDetail({
              jpReceBasicInfo: this.jpReceEditForm,
              jpReceDetailInfoList: this.jpReceDetailInfo,
            })
              .then((res) => {
                this.numLoads = 1;
                Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
                //検索処理を行う
                this.getJpReceDetailByReceNo();
                // 異常製品追加画面
                this.showDueDateEditDialogProc(row);
              })
              .catch((err) => {
                this.showFlag = false;
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
                }
              });
          })
          .finally(() => {
            if (this.showFlag) {
              this.showFlag = false;
            }
          });
        // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
      } else {
        this.dataAddUpdProc();
        updateJpReceDetail({
          jpReceBasicInfo: this.jpReceEditForm,
          jpReceDetailInfoList: this.jpReceDetailInfo,
        })
          .then((res) => {
            this.numLoads = 1;
            Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
            //検索処理を行う
            this.getJpReceDetailByReceNo();
            // 異常製品追加画面
            this.showDueDateEditDialogProc(row);
          })
          .catch((err) => {
            this.showFlag = false;
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
            }
          });
      }
    },
    // 異常製品追加画面
    showDueDateEditDialogProc(row) {
      ShowDueDateEditDialog(
        {
          isKbn: STR_FOUR,
          rowData: row,
          procKbn: row.procKbn,
          aobQuoteNo: row.jrdQuoteNo,
          aodDataProdNo: row.jrdProdNo,
          jrbReceNo: this.jpReceEditForm.jrbReceNo,
          jrdReceDetailNo: row.jrdReceDetailNo,
          odOrderNo: row.jrdOrderNo,
        },
        t("resource.DUE_DATE_EDIT.ERR_PROD_ADD"),

        (target) => {
          this.numLoads = 1;
          //日本入荷No.による日本入荷詳細情報の取得
          this.getJpReceDetailByReceNo();
        }
      );
    },
    // ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 end↑

    // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
    // 日本入荷詳細画面の検索キー(曖昧検索「図番」または「手配No.」)を追加する

    // 全て製品表示の変化を監視する
    handleSearchChange() {
      // 一覧情報（画面表示）
      this.filteredDetailTable = this.jrbReceInfoTable;

      this.searchWord = this.searchWord.trim();
      if (
        this.searchWord !== STR_EMPTY &&
        this.searchWord !== undefined &&
        this.searchWord !== null
      ) {
        this.filteredDetailTable = this.filteredDetailTable.filter((data) => {
          return (
            (data.jrdOrderNoShow &&
              data.jrdOrderNoShow.includes(this.searchWord)) || // 手配NO.
            (data.aodProdDrawNo && data.aodProdDrawNo.includes(this.searchWord)) // 図番
          );
        });
      }

      this.dataProcess();
    },
    // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
.el-table__body {
  height: 200px;
}
</style>
